import React from "react";
import { FaShippingFast, FaLeaf, FaTractor, FaTags, FaShieldAlt, FaAward } from "react-icons/fa";

const features = [
  {
    icon: FaShippingFast,
    title: "Fast Delivery",
    desc: "Quick dispatch to your doorstep",
    color: "text-emerald-600 bg-emerald-50",
  },
  {
    icon: FaLeaf,
    title: "Quality Produce",
    desc: "Handpicked fresh everyday",
    color: "text-green-600 bg-green-50",
  },
  {
    icon: FaTractor,
    title: "Direct Sourcing",
    desc: "Straight from local farms",
    color: "text-amber-600 bg-amber-50",
  },
  {
    icon: FaTags,
    title: "Best Prices",
    desc: "Fair & predictable pricing",
    color: "text-blue-600 bg-blue-50",
  },
  {
    icon: FaShieldAlt,
    title: "100% Secure",
    desc: "Multiple safe payment modes",
    color: "text-indigo-600 bg-indigo-50",
  },
  {
    icon: FaAward,
    title: "Customer First",
    desc: "Dedicated support & rewards",
    color: "text-purple-600 bg-purple-50",
  },
];

const WhyChooseUs = () => {
  return (
    <section className="bg-white py-4 sm:py-6 border-t border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Compact Header */}
        <div className="mb-4 flex flex-wrap items-center justify-between gap-2">
          <div className="flex items-center gap-2">
            <span className="h-2 w-2 rounded-full bg-primary-500 animate-ping" />
            <h2 className="text-base font-bold text-gray-900 sm:text-lg">
              Why choose Kisan Daily Fresh?
            </h2>
          </div>
          <span className="text-xs font-semibold uppercase tracking-wider text-amber-600 bg-amber-50 px-2.5 py-1 rounded-full border border-amber-200/60">
            Why Customers Stay
          </span>
        </div>

        {/* Compact Grid */}
        <div className="grid grid-cols-2 gap-2.5 sm:grid-cols-3 lg:grid-cols-6 sm:gap-3">
          {features.map((feature) => {
            const Icon = feature.icon;
            return (
              <div
                key={feature.title}
                className="group flex flex-col items-center text-center p-3 rounded-2xl border border-gray-100 bg-white transition-all duration-300 hover:border-primary-200 hover:shadow-md"
              >
                <div className={`mb-2 flex h-9 w-9 items-center justify-center rounded-xl ${feature.color} transition-transform duration-300 group-hover:scale-110`}>
                  <Icon className="h-4 w-4" />
                </div>
                <h3 className="text-xs font-bold text-gray-900 leading-tight">
                  {feature.title}
                </h3>
                <p className="mt-0.5 text-[11px] text-gray-500 leading-tight line-clamp-1">
                  {feature.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
